import { render, staticRenderFns } from "./kcardgrid.vue?vue&type=template&id=ddeb533c&scoped=true"
import script from "./kcardgrid.vue?vue&type=script&lang=js"
export * from "./kcardgrid.vue?vue&type=script&lang=js"
import style0 from "./kcardgrid.vue?vue&type=style&index=0&id=ddeb533c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddeb533c",
  null
  
)

export default component.exports